export enum DecisaoPrecoVinculoEnum {
  AceitarAjustarPreco = 1,
  MarcarDivergencia = 2,
}
